const submitComment = async (
  PageId: string,
  Body: string
): Promise<Response> => fetch("/api/CommentsApi/Submit", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify({ PageId, Body })
});

const editComment = async (
  CommentId: string,
  Body: string
): Promise<Response> => fetch("/api/CommentsApi/UpdateComment", {
  method: "PATCH",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify({ CommentId, Body })
});

const deleteComment = async (CommentId: string): Promise<Response> => fetch("/api/CommentsApi/DeleteComment", {
  method: "DELETE",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify({ CommentId })
});

export { submitComment, editComment, deleteComment };
